import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StandardComponent } from './standard.component';

@NgModule({
  declarations: [StandardComponent],
  imports: [
    CommonModule
  ],
  exports: [StandardComponent]
})
export class StandardModule { }
